// Make navigator show Share
interface Navigator {
    share(obj: any): void;
}

// Others
interface Document {
    createElementFromHTML(html: string): HTMLElement;
}
Document.prototype.createElementFromHTML = function (html: string) {
    let template = this.createElement("template");
    template.innerHTML = html;
    return template.content.children[0] as HTMLElement;
}

declare var EasyMDE: any;